module.exports = __webpack_public_path__ + "static/media/force-latest.5118a39a.jpg";